import * as utils from "@/utils.js";

export default {
    getConstructionsData: (state, getters, rootState, rootGetters) => {
        if (
            rootState.user.bpi !== null &&
            rootState.user.bpi.Moyens_fonciers_et_immeubles.length !== 0
        ) {
            const constructionDataProfiles =
                rootState.user.bpi.Moyens_fonciers_et_immeubles;

            const constructions = constructionDataProfiles.map(construction => {
                return {
                    model: "immeuble-card",
                    key: utils.generateUID(),
                    object: {
                        ...construction
                    }
                };
            });
            return constructions;
        }
        if (!rootGetters["user/isSimplifiedVersion"])
            return [
                {
                    model: "immeuble-card",
                    key: utils.generateUID(),
                    object: {
                        id: utils.generateUID(),
                        image: null,
                        buildingType: "terrain",
                        isBuying: "Achat",
                        hasLeasing: true,
                        isRural: false,
                        hasField: false,
                        address: "",
                        Superficie: null,
                        price: null,
                        rent: null,
                        constructionEntry: "quantity",
                        constructionCosts: {
                            batiment: { surface: null, price: null },
                            charpante: { surface: null, price: null },
                            ConstruitEnDur: { surface: null, price: null },
                            fondation: { surface: null, price: null },
                            dallage: { surface: null, price: null },
                            mure: { surface: null, price: null }
                        },
                        constructionTotal: null,
                        FCD: false,
                        formJuridique: null,
                        amenagment: null,
                        landTitle: null,
                        payedInAdvance: null,
                        rentPrice: null,
                        rentDuration: null
                    }
                }
            ];

        return [
            {
                model: "immeuble-card",
                key: utils.generateUID(),
                object: {
                    id: utils.generateUID(),
                    image: null,
                    buildingType: "local_pro",
                    isBuying: "Achat",
                    hasLeasing: true,
                    isRural: false,
                    hasField: false,
                    address: "",
                    Superficie: null,
                    price: null,
                    rent: null,
                    constructionEntry: "quantity",
                    constructionCosts: {
                        batiment: { surface: null, price: null },
                        charpante: { surface: null, price: null },
                        ConstruitEnDur: { surface: null, price: null },
                        fondation: { surface: null, price: null },
                        dallage: { surface: null, price: null },
                        mure: { surface: null, price: null }
                    },
                    constructionTotal: null,
                    FCD: false,
                    formJuridique: null,
                    amenagment: null,
                    landTitle: null,
                    payedInAdvance: null,
                    rentPrice: null,
                    rentDuration: null
                }
            }
        ];
    },

    gettechInstallations: (state, getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            rootState.user.bpi.installations_techniques.length !== 0
        ) {
            const techInstallationsDataProfiles =
                rootState.user.bpi.installations_techniques;

            const installations = techInstallationsDataProfiles.map(
                installation => {
                    return {
                        model: "instalation-tech-card",
                        key: utils.generateUID(),
                        object: {
                            ...installation
                        }
                    };
                }
            );
            return installations;
        }

        return [
            {
                model: "instalation-tech-card",
                key: utils.generateUID(),
                object: {
                    id: utils.generateUID(),
                    isBuying: true,
                    designation: "",
                    number: 1,
                    characteristics: "",
                    state: "",
                    price: null,
                    providerName: "",
                    origin: "",
                    payedInAdvance: null,
                    rentPrice: null,
                    rentDuration: null
                }
            }
        ];
    },

    getTools: (state, getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            rootState.user.bpi.materiels_et_outillage.length !== 0
        ) {
            const toolsDataProfiles = rootState.user.bpi.materiels_et_outillage;

            const tools = toolsDataProfiles.map(tool => {
                return {
                    model: "tools-card",
                    key: utils.generateUID(),
                    object: {
                        ...tool
                    }
                };
            });
            return tools;
        }

        return [
            {
                model: "tools-card",
                key: utils.generateUID(),
                object: {
                    id: utils.generateUID(),
                    isBuying: true,
                    designation: "",
                    number: 1,
                    characteristics: "",
                    state: "",
                    price: null,
                    providerName: "",
                    origin: "",
                    payedInAdvance: null,
                    rentPrice: null,
                    rentDuration: null
                }
            }
        ];
    },

    getTransportation: (state, getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            rootState.user.bpi.moyens_de_transports_et_manutentions.length !== 0
        ) {
            const transportationsDataProfiles =
                rootState.user.bpi.moyens_de_transports_et_manutentions;

            const transportations = transportationsDataProfiles.map(
                transportation => {
                    return {
                        model: "transportation-card",
                        key: utils.generateUID(),
                        object: {
                            ...transportation
                        }
                    };
                }
            );
            return transportations;
        }

        return [
            {
                model: "transportation-card",
                key: utils.generateUID(),
                object: {
                    id: utils.generateUID(),
                    BuyingType: "achat",
                    designation: "",
                    number: 1,
                    characteristics: "",
                    state: "",
                    price: null,
                    providerName: "",
                    origin: "",
                    payedInAdvance: null,
                    rentPrice: null,
                    rentDuration: null
                }
            }
        ];
    },
    /* furnitureCard*/

    getFurnitureCard: (state, getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            rootState.user.bpi.mobilier_et_bureaux.length !== 0
        ) {
            const furnitureCardDataProfiles =
                rootState.user.bpi.mobilier_et_bureaux;

            const furnitureCards = furnitureCardDataProfiles.map(
                furnitureCard => {
                    return {
                        model: "furniture-card",
                        key: utils.generateUID(),
                        object: {
                            ...furnitureCard
                        }
                    };
                }
            );
            return furnitureCards;
        }

        return [
            {
                model: "furniture-card",
                key: utils.generateUID(),
                object: {
                    id: utils.generateUID(),
                    image: null,
                    designation: "",
                    nombre: 1,
                    caracteristique: "",
                    etat: "",
                    prix: null,
                    nomFournisseur: "",
                    origine: ""
                }
            }
        ];
    },

    /* techHardware */
    getTechHardware: (state, getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            rootState.user.bpi.materiel_informatique.length !== 0
        ) {
            const techHardwareCardDataProfiles =
                rootState.user.bpi.materiel_informatique;

            const techHardwares = techHardwareCardDataProfiles.map(
                techHardware => {
                    return {
                        model: "tech-hardware",
                        key: utils.generateUID(),
                        object: {
                            ...techHardware
                        }
                    };
                }
            );
            return techHardwares;
        }

        return [
            {
                model: "tech-hardware",
                key: utils.generateUID(),
                object: {
                    id: utils.generateUID(),
                    image: null,
                    designation: "",
                    nombre: 1,
                    caracteristique: "",
                    etat: "",
                    prix: null,
                    nomFournisseur: "",
                    origine: ""
                }
            }
        ];
    },

    getITMO: (state, getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            rootState.user.bpi.itmo.length !== 0
        ) {
            const ITMOCardData = rootState.user.bpi.itmo;
            const ITMOArrays = ITMOCardData.map(ITMO => {
                return {
                    model: "ITMO",
                    key: utils.generateUID(),
                    object: {
                        ...ITMO
                    }
                };
            });

            return ITMOArrays;
        }

        return [
            {
                model: "ITMO",
                key: utils.generateUID(),
                object: {
                    id: utils.generateUID(),
                    image: null,
                    designation: "",
                    nombre: 1,
                    caracteristique: "",
                    etat: "",
                    prix: null,
                    nomFournisseur: "",
                    origine: ""
                }
            }
        ];
    },

    /* labourCard */
    getLabourCard: (state, getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            rootState.user.bpi.moyens_humains.length !== 0
        ) {
            const labourCardProfiles = rootState.user.bpi.moyens_humains;

            return [...labourCardProfiles];
        }

        return [];
    }
};
